import React from "react"
import "./styles.css"

const AppointmentCard = ({
  appointment,
  color = "#333",
  handleSetView,
  updateQuantity,
}) => {
  const {
    title = "",
    duration = "",
    image = "",
    price = "",
    quantity = 0,
  } = appointment

  return (
    <div className="ct-modal__confirm-card">
      <div className="ct-modal__confirm-card--image">
        <img src={image} alt="" />
      </div>
      <div className="ct-modal__confirm-card--content">
        <div className="ct-modal__confirm-card--heading--container">
          <span className="ct-modal__confirm-card--heading">{title}</span>
        </div>
        {/* <span className="ct-modal__confirm-card--subheading">Duration: {duration}</span> */}
        <span className="ct-modal__confirm-card--quantity">
          Quantity: {quantity}
        </span>
      </div>
      {/* <div className="ct-modal__confirm-card--quantity-container">
        <span className="ct-modal__confirm-card--quantity">Quantity: {quantity}</span>
      </div> */}
      <div className="ct-modal__confirm-card--price-container">
        <span className="ct-modal__confirm-card--price">
          ${(price * quantity).toFixed(2)}
        </span>
      </div>
    </div>
  )
}

export default AppointmentCard
